import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Link } from 'react-router-dom';
import ApiCall from '../../utils/Api';
import { Button } from '@mui/material';
import {convertDateFormat,extractTimeFromTimestamp} from "../../utils/services";

function createData(name, code,address, price, units,Revenue) {
  return { name, code, address, price, units,Revenue };
}                                                                                 
// const [changeColor,setchangeColor]=useState("")
const rows = [
  createData('Sep 26, 2023 8:26 AM ET', "FX", "NOR-FX-TDU-6M-FWD-2023-09-26", 6000 , 20,12000),
  createData('Sep 26, 2023 8:26 AM ET', "FX", "NOR-FX-TDU-6M-FWD-2023-09-26", 6000, 20,12000),
  createData('Sep 26, 2023 8:26 AM ET', "FX", "NOR-FX-TDU-6M-FWD-2023-09-26", 6000, 20,14500),
  createData('Sep 26, 2023 8:26 AM ET', "FX", "NOR-FX-TDU-6M-FWD-2023-09-26", 6000, 20,34532),
  createData('Sep 26, 2023 8:26 AM ET', "FX", "NOR-FX-TDU-6M-FWD-2023-09-26", 6000, 20,20000),
];

// export default function ProviderApprovalRequestTable() {
//      const [data,setData]=useState([])
//      const [email,setRejectUser]=useState("")
//      const [updateCount,setupdateCount]=useState(0)
//      const role = localStorage.getItem("role");

//      console.log("role is " , role )
//      useEffect(()=>{
//           const getAllProviderRequest=async()=>{
//             let data=await ApiCall.SECURE_API.post("/admin/getApprovalRequests")
//             console.log("🚀 ~ file: ProviderApprovalRequestTable.js:18 ~ getAllProviderRequest ~ data:", data.data.request)
//             setData(data.data.request)
//           }
//           getAllProviderRequest()
//      },[updateCount])
//      const [AcceptUser,setAcceptUser]=useState("")

//      const RejectProvider=async()=>{
//       let data=await ApiCall.SECURE_API.delete("/admin/deleteprovider",{
//         "email":email
//       })
//       console.log("🚀 ~ file: ProviderApprovalRequestTable.js:40 ~ RejectProvider ~ data:", data)
      
//      }
//      const RejectProviderAccept=async(data2)=>{
//       console.log("🚀 ~ RejectProviderAccept ~ RejectProviderAccept:",data2)
//       let data=await ApiCall.SECURE_API.post("/admin/approveProvider",{
//         "email":data2
//       })
//       setupdateCount(updateCount+1)
//       console.log("🚀 ~ file: ProviderApprovalRequestTable.js:40 ~ RejectProvider ~ data:", data)
      
//      }
//      function formatEtherFromWei(weiValue, decimalPlaces) {
//       // Convert wei to ether using Web3.js utility function
//       const etherValue = web3.utils.fromWei(weiValue, "ether");
  
//       // Limit the ether value to a specified number of decimal places
//       const formattedEther = parseFloat(etherValue).toFixed(decimalPlaces);
  
//       // Return the formatted ether value with "ETH" appended
//       return formattedEther + " ETH";
//   }
//   return (
//     <TableContainer style={{borderRadius:9}} component={Paper}>
//       <Table sx={{ minWidth: 650 }} aria-label="simple table">
//         <TableHead style={{backgroundColor:"Black"}}>
//           <TableRow>
//             <TableCell align="center" style={{color:"white"}}>Date & Time Created</TableCell>
//             <TableCell align="center" style={{color:"white"}}>InstitutionName</TableCell>
//             <TableCell align="center" style={{color:"white"}}>Email</TableCell>
//             <TableCell align="center" style={{color:"white"}}>Wallet Address</TableCell>
//             <TableCell align="center" style={{color:"white"}}></TableCell>
//             <TableCell align="center" style={{color:"white"}}></TableCell>

//             {/* <TableCell align="right">Carbs&nbsp;(g)</TableCell>
//             <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {data.map((row,index) => (
//             <TableRow
//               key={index}
//               onClick={()=>{
//                 console.log("===============row.email============>",row.email)
//                 // RejectProvider(row.email)
//                 setRejectUser(row.email)
//               }}
//               sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
//             >
//                          <TableCell align="center">
//                   <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>


//                     <div style={{ display: "flex", flexDirection: "column" ,alignItems:"flex-start"}}> 
//                     <span style={{fontWeight:600}}> {convertDateFormat(row.createdAt)}</span><span style={{color:"gray"}}> {extractTimeFromTimestamp(row.createdAt)}</span>             
//                     </div>
//                     </div>
//                 </TableCell>
             
//               <TableCell align="center">{row.institutionName}</TableCell>
//               <TableCell align="center">{row.email}</TableCell>
//               <TableCell align="center">{row.walletAddress}</TableCell>
//               <TableCell align="center"> <Button onClick={RejectProvider} style={{backgroundColor:"red",color:"pink"}}>Reject</Button> </TableCell>
//               <TableCell align="center"><Button onClick={()=>{RejectProviderAccept(row.email)}} style={{backgroundColor:"lightgreen",color:"green"}}>Accept</Button></TableCell>

//               {/* <TableCell align="center"><Link to="PermissionsDetail">View Detail</Link></TableCell> */}

//             </TableRow>
//           ))}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   );
// }


export default function ProviderApprovalRequestTable({ onRequestCountChange }) {
  const [data, setData] = useState([]);
  const [email, setRejectUser] = useState("");
  const [updateCount, setUpdateCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const role = localStorage.getItem("role");

  console.log("🚀 ~ ProviderApprovalRequestTable ~ role is ", role);
  console.log("🚀 ~ ProviderApprovalRequestTable ~ Component rendering...");

  useEffect(() => {
      const getAllProviderRequest = async () => {
          try {
              let response;
              if (role === "Admin") {
                  response = await ApiCall.SECURE_API.post("/admin/getApprovalRequests");
              } else if (role === "Fund Subscriber") {
                  response = await ApiCall.SECURE_API.post("/fundSubscriber/getApprovalRequests");
              } else {
                  console.warn("Invalid role:", role);
                  return;
              }

              console.log("🚀 Data fetched:", response.data.request);
              console.log("🚀 Data length:", response.data.request ? response.data.request.length : 0);
              setData(response.data.request);
              setIsLoading(false);
              
              // Notify parent component about the count change
              if (onRequestCountChange) {
                const count = response.data.request ? response.data.request.length : 0;
                console.log("🚀 Notifying parent with count:", count);
                onRequestCountChange(count);
              }
          } catch (error) {
              console.error("Error fetching provider requests:", error);
              setIsLoading(false);
          }
      };

      getAllProviderRequest();
  }, [updateCount, role]);

  const RejectProvider = async () => {
      try {
          let response = await ApiCall.SECURE_API.delete("/admin/deleteprovider", {
              "email": email
          });
          console.log("🚀 Provider Rejected:", response);
          setUpdateCount(prev => prev + 1);
      } catch (error) {
          console.error("Error rejecting provider:", error);
      }
  };

  const RejectProviderAccept = async (email) => {
      try {
          let response;
          if (role === "Admin") {
              response = await ApiCall.SECURE_API.post("/admin/approveProvider", { email });
          } else if (role === "Fund Subscriber") {
              response = await ApiCall.SECURE_API.post("/fundSubscriber/approveProvider", { email });
          } else {
              console.warn("Invalid role for approving provider");
              return;
          }

          console.log("🚀 Provider Approved:", response);
          setUpdateCount(prev => prev + 1);
      } catch (error) {
          console.error("Error approving provider:", error);
      }
  };

  return (
      <TableContainer style={{ borderRadius: 9 }} component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead style={{ backgroundColor: "Black" }}>
                  <TableRow>
                      <TableCell align="center" style={{ color: "white" }}>Date & Time Created</TableCell>
                      <TableCell align="center" style={{ color: "white" }}>Institution Name</TableCell>
                      <TableCell align="center" style={{ color: "white" }}>Email</TableCell>
                      <TableCell align="center" style={{ color: "white" }}>Wallet Address</TableCell>
                      <TableCell align="center" style={{ color: "white" }}>Actions</TableCell>
                  </TableRow>
              </TableHead>
              <TableBody>
                  {isLoading ? (
                      <TableRow>
                          <TableCell colSpan={5} align="center" style={{padding: '40px'}}>
                              <div style={{fontSize: '16px', color: '#666'}}>
                                  Loading approval requests...
                              </div>
                          </TableCell>
                      </TableRow>
                  ) : data.length > 0 ? (
                      data.map((row, index) => (
                          <TableRow key={index} onClick={() => setRejectUser(row.email)} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                              <TableCell align="center">
                                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                                          <span style={{ fontWeight: 600 }}>{convertDateFormat(row.createdAt)}</span>
                                          <span style={{ color: "gray" }}>{extractTimeFromTimestamp(row.createdAt)}</span>
                                      </div>
                                  </div>
                              </TableCell>
                              <TableCell align="center">{row.institutionName}</TableCell>
                              <TableCell align="center">{row.email}</TableCell>
                              <TableCell align="center">{row.walletAddress}</TableCell>
                              <TableCell align="center">
                                  <Button onClick={RejectProvider} style={{ backgroundColor: "red", color: "white", marginRight: "10px" }}>Reject</Button>
                                  <Button onClick={() => RejectProviderAccept(row.email)} style={{ backgroundColor: "lightgreen", color: "green" }}>Accept</Button>
                              </TableCell>
                          </TableRow>
                      ))
                  ) : (
                      <TableRow>
                          <TableCell colSpan={5} align="center" style={{padding: '40px'}}>
                              <div style={{fontSize: '16px', color: '#666'}}>
                                  No pending approval requests found
                              </div>
                          </TableCell>
                      </TableRow>
                  )}
              </TableBody>
          </Table>
      </TableContainer>
  );
}